const REG_EXP = {
    LETTER_VALIDATOR: /^[a-zA-Z]+$/
}

export default REG_EXP;